import CustomerRefundShipmentsApiV2 from 'api/v2/admins/customer-refund-shipments-api-v2'
import TitlePage from 'components/atoms/title-page'
import CardLoader from 'components/organisms/card-loader'
import CustomerRefundShipmentCard from 'domains/customer-refund-shipment/organisms/card'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Row, Col, Card, CardHeader, CardBody, ListGroup, ListGroupItem } from 'reactstrap'
import CustomerRefundShipmentShipForm from 'domains/customer-refund-shipment/organisms/ship-form'
import CustomerRefundItemView from 'domains/customer-refund/molecules/item-view'
import { ALERT_TYPES } from 'constants/alert-constants'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CustomerRefundShipmentDetailPage = ({ pageUtils }) => {
  const [ refundShipment, setRefundShipment ] = useState({})
  const { id }                                = useParams()
  const [ isLoading, setIsLoading ]           = useState(true)

  const handleFetchCustomerRefundShipment = useCallback((id) => {
    CustomerRefundShipmentsApiV2.show(id)
      .then((response) => {
        setRefundShipment(response.data.refund_shipment)
        setIsLoading(false)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))

  }, [ pageUtils ])

  useEffect(() => {
    handleFetchCustomerRefundShipment(id)
  }, [ handleFetchCustomerRefundShipment, id ])


  const handleSubmit = async (values, formikBag) => {

    await CustomerRefundShipmentsApiV2.ship({
      id     : id,
      values : values
    })
      .then(() => {
        pageUtils.setAlertMsg('The Refund Shipment already shipped.', ALERT_TYPES.SUCCESS)

        /** Refetching the updated Customer Refund Shipment */
        handleFetchCustomerRefundShipment(id)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
        formikBag.setErrors(error.response.data.messages)
      })
  }

  const CustomerRefundShipmentCardWithLoader = withLoader(CustomerRefundShipmentCard, CardLoader)

  const CustomerRefundListGroup = () => (
    <ListGroup>
      {
        refundShipment.refunds && refundShipment.refunds.map((refund) => (
          <ListGroupItem key={ refund.id }>
            <CustomerRefundItemView refund={ refund } />
          </ListGroupItem>
        ))
      }
    </ListGroup>
  )

  return (
    <>
      <TitlePage mainTitle='Customer Refund Shipment' subTitle='Detail Page'/>

      <Row>
        <Col md={ 3 }>
          <Card>
            <CardHeader>
              <h3>{ 'Refund Ship Form' }</h3>
            </CardHeader>
            <CardBody>
              <CustomerRefundShipmentShipForm onSubmit={ handleSubmit } />
            </CardBody>
          </Card>
        </Col>

        <Col md={ 5 }>
          <Card>
            <CardHeader>
              <h3>{ 'Refund Items' }</h3>
            </CardHeader>
            <CustomerRefundListGroup />
          </Card>
        </Col>

        <Col md={ 4 }>
          <CustomerRefundShipmentCardWithLoader
            isLoading={ isLoading }
            refundShipment={ refundShipment }
          />
        </Col>

      </Row>
    </>
  )
}

CustomerRefundShipmentDetailPage.propTypes    = propTypes
CustomerRefundShipmentDetailPage.defaultProps = defaultProps

export default CustomerRefundShipmentDetailPage
